import { Component, OnInit } from '@angular/core';

import { TranslationService } from '@mirage-projects/cw-commons';
import { User } from '@mirage-projects/cw-models';

import { BarListConfigurationService, ItemBar } from '@collageweb/services/bar-list-configuration.service';

@Component({
    selector: 'cw-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false,
})
export class SidebarComponent implements OnInit {
    user: User | null = null;
    sideBarItems: ItemBar[] = [];
    currentLanguage = '';
    constructor(
        private barListService: BarListConfigurationService,
        public translationService: TranslationService
    ) {}

    ngOnInit(): void {
        this.sideBarItems = this.barListService.getSideBarElements();
        this.currentLanguage = this.translationService.currentLang;
    }
}
